export const SALES_FLOW_DATE_FIELDS = [
    { value: 'appointment.startDate', label: 'Data do agendamento' },
    { value: 'deal.expectedCloseDate', label: 'Previsão de fechamento da oportunidade' },
];
/** Fluxos criados pelo próprio produto, fora da tela de fluxos (`SalesFlow.systemKey`). */
export const SALES_FLOW_SYSTEM_KEYS = {
    /** "Agendar envio" do chat: pausa até `scheduledAt` e envia `message` pelo setor da conversa. */
    SCHEDULED_MESSAGE: 'SCHEDULED_MESSAGE',
};
//# sourceMappingURL=types.js.map